import { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
import { payloadTeam } from "../entities/TeamEntity";

const getAllTeam = async (payload: payloadTeam) => {
  const url = `${BASE_URL}/auth/team/find-team`;
  return await httpClient.get(url, { params: payload }).then((res: AxiosResponse) => res.data);
};
const getTeamById = async (teamId?: string) => {
  const url = `${BASE_URL}/auth/team/find-team-by-id/${teamId}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};
const postTeam = async (payload: { company: string; teamName: string; updatedBy: string }) => {
  return await httpClient
    .post(`${BASE_URL}/auth/team/create-team`, payload)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const patchTeam = async (payload: {
  teamId: string;
  company: string;
  teamName: string;
  status: string;
  updatedBy: string;
}) => {
  return await httpClient
    .post(`${BASE_URL}/auth/team/create-team`, payload)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const multiTeamZone = async (obj: object) => {
  return await httpClient
    .post(`${BASE_URL}/auth/team/find-multi-team-with-zone`, obj)
    .then((res: AxiosResponse) => res.data.responseData)
    .catch((err) => console.log(err));
};
const deleteUserTeamZone = async (obj: object) => {
  return await httpClient
    .post(`${BASE_URL}/auth/user-staff/delete-user-staff-team-zone`, obj)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const teamDatasource = {
  deleteUserTeamZone,
  getAllTeam,
  getTeamById,
  postTeam,
  patchTeam,
  multiTeamZone,
};
